import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_PROVIDER_KEY_LIST_W_DATES_REQUEST: '',
  GET_PROVIDER_KEY_LIST_W_DATES_SUCCESS: '',
  GET_PROVIDER_KEY_LIST_W_DATES_FAILURE: '',

  GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_REQUEST: '',
  GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_SUCCESS: '',
  GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_FAILURE: '',

};

types = setStoreTypeValues(types, 'appProviderKeyListWDates');

export default types;
